import { getInstrumentById } from '@/Wist-blockchain/collections/instruments/instruments.service'
import EditInstrument from '@/Wist-blockchain/instruments/view/user/editInstrument'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/instruments/$id/edit')({
    beforeLoad: ({ context }) => {
        if (!context.user) throw redirect({ to: '/login' })
        const { isServicioTecnico, isAdmin } = context.userRoles
        if (!isServicioTecnico && !isAdmin) throw redirect({ to: '/unauthorized' })
    },
    loader: async ({ params }) => {
        const instrument = await getInstrumentById(params.id)
        return { instrument }
    },
    staleTime: 0,
    errorComponent: () => <div>Equipo no encontrado.</div>,
    component: () => {
        const { instrument } = Route.useLoaderData()
        return <EditInstrument instrument={instrument} />
    },
})
